import React, {useRef} from "react";
import useZustandStore from "../hooks/useZustandStore";
import ChapterHeader from "./reading/ChapterHeader";
import LoadingSkeleton from "./reading/LoadingSkeleton";
import {TextBlock, SepBlock, CommentaryBlock, TranslationBlock} from "./reading/ContentBlocks";

function ReadingArea({
    fontSize, lineHeight,
    showTranslation, showCommentary,
    onProgress, onCharHover, onCharLeave,
    isLoading,
}) {
    const areaRef = useRef(null);
    const activeBook = useZustandStore((state) => state.activeBook);
    const chapterTitle = useZustandStore((state) => state.chapterTitle);
    const chapterOrd = useZustandStore((state) => state.chapterOrd);
    const blocks = useZustandStore((state) => state.chapterBlocks);

    const handleScroll = () => {
        const el = areaRef.current;
        if (!el) return;
        const pct = (el.scrollTop / (el.scrollHeight - el.clientHeight)) * 100;
        onProgress(Math.min(100, pct || 0));
    };

    return (
        <div ref={areaRef} onScroll={handleScroll} className="flex-1 overflow-y-auto relative z-[1] scrollbar-paper">
            <div className="max-w-[720px] mx-auto px-4 md:px-10 pt-8 md:pt-14 pb-16 md:pb-20">
                <ChapterHeader title={chapterTitle} ord={chapterOrd} book={activeBook} loading={isLoading}/>

                {isLoading && <LoadingSkeleton />}
                {!isLoading && blocks.length === 0 && (
                    <div className="text-center text-ink-faint/50 mt-20 font-serif tracking-[4px]">
                        ← 从侧边栏选择书目，从右侧目录选择章节
                    </div>
                )}
                {blocks.map((block, i) => {
                    switch (block.type) {
                        case "text":
                            return <TextBlock key={i} block={block} fontSize={fontSize} lineHeight={lineHeight}
                                onCharHover={onCharHover} onCharLeave={onCharLeave} />;
                        case "translation":
                            return showTranslation && <TranslationBlock key={i} block={block} />;
                        case "commentary":
                            return showCommentary && <CommentaryBlock key={i} block={block} />;
                        case "sep":
                            return <SepBlock key={i} block={block} />;
                        default:
                            return null;
                    }
                })}
            </div>
        </div>
    );
}

export default React.memo(ReadingArea);